import { AD_SERVERS, STATE_SERVICE } from '../../../configs/constants';
import {
    destroyAllSlots,
    embeddingSlots,
    handleSlotRenderEnded,
    handleSlotRequested,
    prepareInitialDFPServiceConfig,
    setGPTConfig,
    setGPTTargeting,
} from './embedding-dfp.utils';
import { setAdServicesState } from '../ad-services.utils';
import { loadGPTScript } from '../../../helpers/load-gpt-script';
import DebugUANC from '../../../core/version/debug';

const processEmbeddingDFP = () => {
    const { UANC, exSettings, event: uancEvent } = window.Inpl.Ad;

    // przygotowanie defaultowej/startowej konfiguracji DFPService
    window.Inpl.Ad.services = {
        ...window.Inpl.Ad.services,
        resolved: false,
        DFPService: prepareInitialDFPServiceConfig(),
    };

    destroyAllSlots(); // dla pewności usuwamy wcześniej zdefiniowane jednostki reklamowe

    // w przypadku braku slotów kończymy działanie embedding DFP
    if (!window.Inpl.Ad.services.DFPService?.slots.length) {
        UANC!.unresolvedServices = UANC!.unresolvedServices.filter((service) => service !== AD_SERVERS.DFP);
        console.info('DFPService finished - no slots to embedding.');
        return;
    }

    setGPTConfig(); // konfiguracja serwera, włączenie usług
    setGPTTargeting(); // ustawienie targetingu - url, params, adultContent, keywords pluginów
    !exSettings?.designSystem && embeddingSlots(); // osadzanie reklam z konfiguracji ADC

    uancEvent?.add('slotRequested', googletag.pubads(), handleSlotRequested); // nasłuchiwanie na wysyłkę requestu do adserwera
    uancEvent?.add('slotRenderEnded', googletag.pubads(), handleSlotRenderEnded); // nasłuchiwanie na event zakończenia renderowania slotu

    setAdServicesState(AD_SERVERS.DFP, STATE_SERVICE.READY); // DFPService gotowe do użycia
};

export default async (): Promise<void> => {
    const { UANC } = window.Inpl.Ad;
    UANC!.unresolvedServices.push(AD_SERVERS.DFP);

    window.googletag = window.googletag || {};
    window.googletag.cmd = window.googletag.cmd || [];
    if (!window.googletag.apiReady) {
        try {
            await loadGPTScript();
            window.googletag.cmd.push(() => {
                UANC?.setState({ isGoogleScriptReady: true });
                processEmbeddingDFP();
            });
        } catch (e) {
            UANC instanceof DebugUANC && UANC.error(`[GPTScript] Problem with GPT script - ${e}`);
            UANC?.setState({ isGoogleScriptReady: false });
            setAdServicesState(AD_SERVERS.DFP, STATE_SERVICE.REJECTED);
            return;
        }
    } else {
        UANC?.setState({ isGoogleScriptReady: true });
        processEmbeddingDFP();
    }
};
